import { environmentCommon } from '../../../environments/environment';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SaveYourWorkModalComponent } from './save-your-work-modal/save-your-work-modal.component';
import { CartModule } from '@legalzoom/cart-sdk';
import { UserCartService } from '../services/user-cart.service';
import { CustomerModule } from '@legalzoom/customer-sdk';


@NgModule({
  imports: [
    CommonModule, ReactiveFormsModule,
    CartModule.forRoot(environmentCommon),
    CustomerModule.forRoot(environmentCommon)
  ],
  declarations: [SaveYourWorkModalComponent],
  entryComponents: [SaveYourWorkModalComponent],
  providers: [UserCartService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class GloLoginModalModule { }
